<template>
  <div class="px-3 py-2" :class="[className]" :style="styleCard">
    <div class="flex-center-vertical is-justify-content-space-between">
      <div class="flex-center mr-3">
        <NotificationTiltedIcon />
        <div class="ml-2">
          <p class="averta-bold label-12">{{ statusWorker }}</p>
          <p class="averta-reguler-italic label-12 has-text-left">{{ data.company_name }}</p>
        </div>
      </div>
      <div
        class="flex-center border-radius-100 py-1 px-2 cursor-pointer"
        :class="classNameBadge"
        @click="redirectSurvey(data.project_id)"
      >
        <p class="averta-bold mr-1 label-12">ID{{ data.survey_id }}</p>
        <ArrowRightIconLong color="#E10009" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CardWorkerConflict',
  props: {
    className: {
      type: String,
      default: 'bg-white border-radius-5'
    },
    classNameBadge: {
      type: String,
      default: 'bg-grey-3'
    },
    width: {
      type: String,
      default: '100%'
    },
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    NotificationTiltedIcon: () => import('@/components/icons/NotificationTiltedIcon'),
    ArrowRightIconLong: () => import('@/components/icons/ArrowRightIconLong')
  },
  computed: {
    ...mapGetters({
      url: 'setup/getUrl',
      user: 'auth/user'
    }),
    styleCard () {
      return {
        width: this.width
      }
    },
    statusWorker () {
      const status = this.data.status
      if (status === 'booking') {
        return 'Sedang Di Booking'
      } else if (status === 'working') {
        return 'Sedang Di Assign'
      }
      return ''
    },
    isBS () {
      if (
        this.user.roles[0].name === 'Account Manager' ||
        this.user.roles[0].name === 'Business Support'
      ) {
        return true
      }
      return false
    }
  },
  methods: {
    redirectSurvey (projectId) {
      const prefix = this.isBS ? 'am' : 'sm'
      const url = `/#/${prefix}/project/${projectId}/detail`
      window.open(url, '_blank')
    }
  }
}
</script>
